<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { mapState } from 'vuex'

const MENU_PAGE_MAP = {
  // 下级渠道商客户
  SUBORDINATE_SERVICE_PROVIDER_CUSTOMERS: 'partnerServiceProviderClientd2',
  // 下级渠道商
  SUBORDINATE_CHANNEL: 'partnerServiceProviderd2',
  // 我的渠道商销售业绩
  MY_CHANNEL_SALES_PERFORMANCE: 'serviceprovidersalesperformanced2',
  // 返佣管理
  RETURN_MANAGEMENT: 'rebated2',
  // 代付订单
  PAYMENT_ORDER: 'paylist1',
  // 结算账单
  SETTLEMENT_BILL: 'channel_Checkout1',
  // 渠道客户资源
  CHANNEL_CUSTOMER_RESOURCES: 'customerResource',
}

export default {
  name: 'App',
  computed: mapState({
    distributorInfo: (state) => state.distributor.distributorInfo,
  }),
  watch: {
    distributorInfo: {
      handler(newVal) {
        this.updateHiddenLinks(newVal)
      },
      immediate: true,
    },
  },
  mounted() {
    let _ynavi = null
    Object.defineProperty(window, 'Ynavi', {
      get: () => _ynavi,
      set: (newVal) => {
        _ynavi = newVal
        if (newVal && this.distributorInfo) {
          this.updateHiddenLinks(this.distributorInfo)
        }
      },
      configurable: true,
    })
  },
  methods: {
    updateHiddenLinks(distributorInfo) {
      if (!window.Ynavi || !distributorInfo) return

      this.$nextTick(() => {
        const { distributorLevel, distributorType } = distributorInfo

        // distributorLevel 为 1 时，隐藏 MENU_PAGE_MAP 中的所有页面
        if (distributorLevel === 1) {
          Object.values(MENU_PAGE_MAP).forEach((pageId) => {
            window.Ynavi.hideLink(pageId)
          })
          return
        }

        // 根据 distributorType 隐藏特定页面
        if (distributorType === 0) {
          window.Ynavi.hideLink(MENU_PAGE_MAP.RETURN_MANAGEMENT)
        } else if (distributorType === 1) {
          window.Ynavi.hideLink(MENU_PAGE_MAP.SETTLEMENT_BILL)
        }
      })
    },
  },
}
</script>

<style lang="less">
.el-collapse__container {
  width: 100%;
}
.servicesLineSelect {
  > .el-select {
    width: 100%;
  }
}
</style>
